import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SharedVehicleGroupAdminModel } from '../models/sharedvehiclegroupadmin.model';
import { SharedVehicleGroupAdminService } from '../models/sharedvehiclegroupadmin.service';
import { PersonModel } from '../../person/models/person.model';
import { PersonService } from '../../person/models/person.service';
import { SharedVehicleGroupModel } from '../../sharedvehiclegroup/models/sharedvehiclegroup.model';
import { SharedVehicleGroupService } from '../../sharedvehiclegroup/models/sharedvehiclegroup.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, DataListModel } from '../../shared/config';
import { Location } from '@angular/common';


@Component({
  selector: 'wego-sharedvehiclegroupadmin-list',
  template: require('../views/sharedvehiclegroupadmin-list.component.html'),
  providers: [SharedVehicleGroupAdminService, PersonService, SharedVehicleGroupService],
})
export class SharedVehicleGroupAdminListComponent implements OnInit {
  DataListModel: DataListModel;
  sub: any;
  sharedVehicleGroupHashId: string;
  sharedVehicleGroupAdminList: SharedVehicleGroupAdminModel[];
  apiErrorMsg: string;
  isLoading: boolean;
  deleteSharedVehicleGroupAdminHashId: string;
  message: string;
  errorMessage: string;
  groupName: string;
  isParentCheck: boolean;
  isMultipleDelete: boolean;
  deleteMessage: string;
  urlDefaultPage: string;
  urlSVGList: string;
  resetPasswordPersonHashId: string;
  blockUnblockMsg: string;
  blockUnblockSVGAdminHashId: string;
  blockMsg: string;
  private popupMsg: string;
  private popupTitle: string;
  private module: string;
  lblActive: string;
  lblInactive: string;
  private breadCrumbList: string;
  private sharedvehiclegroupList: string;

  @ViewChild('alertModal') public alertModal: any;
  @ViewChild('addSharedVehicleGroupAdminModal') public addSharedVehicleGroupAdminModal: any;
  @ViewChild('resetPasswordModal') public resetPasswordModal: any;
  @ViewChild('inActiveModal') public inActiveModal: any;
  @ViewChild('successPopup') public successPopup: any;

  get isAnyChecked(): boolean {
    if (this.sharedVehicleGroupAdminList) {
      let isCheck = this.sharedVehicleGroupAdminList.filter(x => x.isUserGroupAdmin == false).some(x => x.isChecked == true);
      if (isCheck) {
        if (this.sharedVehicleGroupAdminList.filter(x => x.isUserGroupAdmin == false).every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }

      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }

  constructor(private sharedVehicleGroupAdminService: SharedVehicleGroupAdminService,
    private personService: PersonService,
    private sharedvehiclegroupService: SharedVehicleGroupService,
    private authService: AuthService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private locationService: Location) {
  }

  ngOnInit() {
    this.lblActive = this.translate.instant('LblActive');
    this.lblInactive = this.translate.instant('LblInactive');
    this.module = this.translate.instant('LblSharedVehicleGroupAdmin');
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.sharedvehiclegroupList = this.translate.instant('LblListPage', [this.translate.instant('LblSharedVehicleGroup')]);
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["userName", "firstName", "lastName"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlSVGList = this.authService.GetURL(ApplicationRouteURL.URL_SVG_LIST);
    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.sharedVehicleGroupHashId = params['sharedvehiclegroupHashId'] || '';
        if (this.sharedVehicleGroupHashId != '') {
          this.GetSharedVehicleGroupAdminList();
          this.GetSharedVehicleGropuDetailsByHashId()
        }
      });
  }

  public GetSharedVehicleGropuDetailsByHashId() {
    this.sharedvehiclegroupService.GetSharedVehicleGroupBasicDetail(this.sharedVehicleGroupHashId)
      .subscribe(
      res => {
        this.groupName = res.data.entityName;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public GetSharedVehicleGroupAdminList() {
    this.isLoading = true;
    this.sharedVehicleGroupAdminService.GetSharedVehicleGroupAdminList(this.sharedVehicleGroupHashId, this.DataListModel)
      .subscribe(
      res => {
        this.sharedVehicleGroupAdminList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetSharedVehicleGroupAdminList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetSharedVehicleGroupAdminList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetSharedVehicleGroupAdminList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetSharedVehicleGroupAdminList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.sharedVehicleGroupAdminService.ExportSharedVehicleGroupAdminList(this.sharedVehicleGroupHashId, this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "SharedVehicleGroupAdminList" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });;
  }

  public OnParentCheck(isChecked: boolean) {
    this.sharedVehicleGroupAdminList.filter(x => x.isUserGroupAdmin == false).forEach(x => x.isChecked = isChecked);
  }

  // Delete shared vehicle group admin
  public DeleteSharedVehicleGroupAdmin(deleteSharedVehicleGroupAdminList: string[]) {
    this.isLoading = true;
    this.sharedVehicleGroupAdminService.DeleteSharedVehilceGroupAdmin(deleteSharedVehicleGroupAdminList)
      .subscribe(
      res => {
        this.DataListModel.currentPage = 1;
        this.GetSharedVehicleGroupAdminList();
        this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.module]);
        this.ShowSuccessPopup();
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowAlertModal(sharedVehicleGroupAdminHashId?: string): void {
    if (sharedVehicleGroupAdminHashId) {
      this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
      this.isMultipleDelete = false;
      this.deleteSharedVehicleGroupAdminHashId = sharedVehicleGroupAdminHashId;
    }
    else {
      this.popupMsg = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
      this.isMultipleDelete = true;

    }
    this.alertModal.show();
  }

  public HideAlertModal(): void {
    this.deleteSharedVehicleGroupAdminHashId = "";
    this.deleteMessage = "";
    this.alertModal.hide();
  }

  public SuccessAlertModalClick(): void {
    let deleteSharedVehicleGroupAdminList: any[];
    if (this.isMultipleDelete)
      deleteSharedVehicleGroupAdminList = this.sharedVehicleGroupAdminList.filter(x => x.isChecked).map(x => x.shareVehicleGroupAdminHashID);
    else
      deleteSharedVehicleGroupAdminList.push(this.deleteSharedVehicleGroupAdminHashId);

    this.DeleteSharedVehicleGroupAdmin(deleteSharedVehicleGroupAdminList);
    this.alertModal.hide();
  }

  // Add shred vehicle group admin popup
  public ShowAddGroupAdminModal() {
    this.addSharedVehicleGroupAdminModal.sharedVehicleGroupHashId = this.sharedVehicleGroupHashId;
    this.addSharedVehicleGroupAdminModal.show();
  }

  public SuccessAddGroupAdminModal($event: any) {
    this.GetSharedVehicleGroupAdminList();
    this.popupMsg = this.translate.instant('LblRecordAddedSuccess', [this.module]);//$event.SuccessMessage;
    this.ShowSuccessPopup();
  }

  //Reset group admin password
  public ResetPersonPassword(personHashID: string) {
    this.personService.ResetPersonPassword(personHashID)
      .subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant('LblResetPasswordSuccess');
          this.ShowSuccessPopup();
        }
        else {
          this.popupMsg = this.translate.instant('LblResetPasswordFailure');
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowResetPasswordModal(personHashID: string): void {
    this.resetPasswordPersonHashId = personHashID;
    this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
    this.resetPasswordModal.show();
  }

  public HideResetPasswordModal(): void {
    this.resetPasswordPersonHashId = "";
    this.resetPasswordModal.hide();
  }

  public SuccessResetPasswordModalClick(): void {
    this.resetPasswordModal.hide();
    this.ResetPersonPassword(this.resetPasswordPersonHashId);
  }

  public ActiveInactiveSVGAdmin() {
    this.isLoading = true;
    this.sharedVehicleGroupAdminService.InActiveSharedVehicleGroupAdmin(this.blockUnblockSVGAdminHashId)
      .subscribe(
      res => {
        if (res.data) {
          this.inActiveModal.hide();
          this.DataListModel.currentPage = 1;
          this.GetSharedVehicleGroupAdminList();
          this.popupMsg = this.translate.instant('LblRecordActiveInActiveSuccess', [this.module, this.blockMsg]);
          this.ShowSuccessPopup();
        }
        else {
          this.isLoading = false;
          this.popupMsg = res.error;
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowInActiveModal(svgAdminHashId: string, isActive: boolean): void {
    this.blockUnblockSVGAdminHashId = svgAdminHashId;
    this.blockMsg = isActive ? this.translate.instant('LblInactive') : this.translate.instant('LblActive');
    let roleType = this.translate.instant('LblSharedVehicleGroupAdmin');
    this.popupMsg = this.translate.instant('LblBlockUnblockConfirm', [this.blockMsg, roleType]);
    this.inActiveModal.show();
  }

  public HideInActiveModal(): void {
    this.inActiveModal.hide();
  }

  public SuccessInActiveModalClick(): void {
    this.ActiveInactiveSVGAdmin();
    this.inActiveModal.hide();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }

  public OnBackClick() {
    this.locationService.back();
  }
  public ResendActivationMail(personHashID: string): void {
    this.resetPasswordPersonHashId = personHashID;    
    this.personService.ReSendActivationMail(personHashID)
      .subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant('LblResendActivationMailSuccess');
          this.ShowSuccessPopup();
        }
        else {
          this.popupMsg = this.translate.instant('LblResendActivationMailFailure');
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/sharedvehiclegroupadmin/components/sharedvehiclegroupadmin-list.component.ts